export default "__VITE_ASSET__e41A1T6n__"